module.exports = __webpack_public_path__ + "static/media/conference-room.00635096.png";